import {
  apiDelete,
  apiGet,
  apiPost,
  apiPut,
  buildQueryString,
  toPositiveInt,
} from "../client";

export async function fetchAdminCourses() {
  return apiGet("/admin/courses");
}

export async function createCourse(title) {
  return apiPost("/admin/courses", { title });
}

export async function updateCourse(id, title) {
  return apiPut(`/admin/courses/${id}`, { title });
}

export async function deleteCourse(id) {
  return apiDelete(`/admin/courses/${id}`);
}

export async function fetchAdminPaths(courseId) {
  return apiGet(
    `/admin/paths${buildQueryString({
      course_id: courseId,
    })}`
  );
}

export async function createPath(courseId, title) {
  return apiPost("/admin/paths", { course_id: courseId, title });
}

export async function updatePath(id, payloadOrTitle) {
  const payload =
    typeof payloadOrTitle === "string"
      ? { title: payloadOrTitle }
      : payloadOrTitle && typeof payloadOrTitle === "object"
      ? { ...payloadOrTitle }
      : {};

  return apiPut(`/admin/paths/${id}`, payload);
}

export async function deletePath(id) {
  return apiDelete(`/admin/paths/${id}`);
}

export async function fetchAdminDays(pathId) {
  return apiGet(
    `/admin/days${buildQueryString({
      path_id: pathId,
    })}`
  );
}

export async function createDay({ path_id, title, day_number }) {
  return apiPost("/admin/days", { path_id, title, day_number });
}

export async function updateDay(id, { title, day_number }) {
  return apiPut(`/admin/days/${id}`, { title, day_number });
}

export async function deleteDay(id) {
  return apiDelete(`/admin/days/${id}`);
}

export async function fetchAdminDayTasksOverview({ courseId, pathId, dayId }) {
  const resolvedDayId = toPositiveInt(dayId);
  if (!resolvedDayId) throw new Error("day id invalid");

  return apiGet(
    `/admin/days/${resolvedDayId}/tasks-overview${buildQueryString({
      course_id: courseId,
      path_id: pathId,
    })}`
  );
}
